// frontend/src/components/Results/PerfopRadarChart.js
// Gráfica de radar (telaraña) con los 9 rasgos de PERFOP, escala 1-10
// (decatipo). Mismo patrón de registro que ResultsChart.js, pero con los
// elementos de Chart.js que necesita un radar en vez de una barra.

import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const PerfopRadarChart = ({ rasgos }) => {
    const lista = Object.values(rasgos || {});
    if (lista.length === 0) return null;

    const data = {
        labels: lista.map(r => r.nombre),
        datasets: [
            {
                label: 'Decatipo',
                data: lista.map(r => r.decatipo),
                backgroundColor: 'rgba(4, 131, 119, 0.25)',
                borderColor: 'rgba(4, 131, 119, 1)',
                borderWidth: 2,
                pointBackgroundColor: 'rgba(4, 131, 119, 1)',
                pointBorderColor: '#fff',
                pointRadius: 4,
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            r: {
                min: 0,
                max: 10,
                ticks: {
                    stepSize: 2,
                    backdropColor: 'transparent',
                    color: '#8a94a6',
                    font: { size: 10 }
                },
                grid: { color: 'rgba(0, 0, 0, 0.08)' },
                angleLines: { color: 'rgba(0, 0, 0, 0.08)' },
                pointLabels: {
                    color: '#4a5568',
                    font: { size: 12, weight: '600' }
                }
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.label}: ${context.raw}/10`
                }
            }
        }
    };

    return (
        <div style={{ height: '380px', margin: '16px 0', backgroundColor: 'white', borderRadius: '16px', padding: '16px' }}>
            <Radar data={data} options={options} />
        </div>
    );
};

export default PerfopRadarChart;
